export default __webpack_public_path__ + "static/referral0-faa36de9811e76fec27ac4cf92352466.png";